import { BRAND_VALUE_FILTER_TYPE, buildFilterKey } from "@faire/retailer-shared/filters/filterKeys";
import { useCategoryPageQueryParams } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useCategoryPageQueryParams";
import { useMemo } from "react";
import { useRouteMatch } from "react-router-dom";
/**
 * This parses the filter keys based on the filters query param from URL,
 * then some ad-hoc logic injects additional filter keys into the list,
 * and returns the final filter keys in sorted order.
 */ export var useCategoryPageFilterKeys = function() {
    var filterKeys = useCategoryPageQueryParams().filterKeys;
    var match = useRouteMatch();
    return useMemo(function() {
        var _match_params_brandValue;
        // We support the URL suffix /brandValue/:brandValue for SEO purpose
        // this value should be treated as an initial value for filters and the
        // "filters" property from query parameter takes precedence
        //
        // Also we prefer dash to underscore in URL, so need to do a conversion before
        // using the value
        var matchedFilterByBrandValue = (_match_params_brandValue = match.params.brandValue) === null || _match_params_brandValue === void 0 ? void 0 : _match_params_brandValue.replace(/-/g, "_");
        if (matchedFilterByBrandValue) {
            var brandValueFilterKey = buildFilterKey(BRAND_VALUE_FILTER_TYPE, matchedFilterByBrandValue);
            if (!filterKeys.includes(brandValueFilterKey)) {
                filterKeys.push(brandValueFilterKey);
            }
        }
        return filterKeys;
    }, [
        filterKeys,
        match.params.brandValue
    ]);
};
